import moment from 'moment'

export default {
  methods: {
    $formatDateStandard(date) {
      return date ? moment(date).format('DD-MM-YYYY') : '-'
    },
    $formatDateString(date) {
      moment.locale('nl')
      return date ? moment(date).format('D MMM YYYY') : '-'
    },
    $formatDateTime(date) {
      return date ? moment(date).format('HH:mm DD-MM-YYYY') : '-'
    },
    $formatDateRelative(date) {
      return date ? moment(date).locale('nl').fromNow() : '-'
    },
  }
}
